// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';
import styles from './CustomSecondaryListItemText.module.scss'; // Import css modules stylesheet as styles
import { StylesContext } from '@material-ui/styles/StylesProvider';

// COMPONENT
export class CustomSecondaryListItemText extends React.Component {
    render() {
        return (
            <div className={styles.textContainer}>
                <div onClick={this.props.onClick} className={styles.text + " " + (this.props.onClick ? styles.link : "")} >
                    { this.props.text }
                </div>
            </div>
        );
    }
}